import axios from 'axios';
import * as firebase from 'firebase';
import Moment from 'moment';
import React, { Component } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { Route, Switch, withRouter } from 'react-router-dom';
import uuid from 'uuid';
import ItemInfo from './AddItem';
import './App.css';
import AreaFalse from './AreaFalse';
import Checkout from './Checkout';
import ChooseArea from './ChooseArea';
import strings from './components/language/language';
import { Provider } from './Context';
import { DesktopContext } from './DesktopContext';
import EditCart from './editcart';
import History from './history';
import Gift from './lottie/Gift';
import RedeemOffer from './lottie/RedeemOffer';
import Ordering from './Ordering';
import CheckoutSuccessAnim from './order_sent';
import Footer from './components/Footer';
import moment from 'moment';

const _matchObjects = (obj1, obj2) => {
  if (obj1 && obj2) {
    var firstobj = Object.keys(obj1);
    var secondobj = Object.keys(obj2);
    if (firstobj.length !== secondobj.length) {
      return false;
    }
    let doesMatch = true;
    firstobj.forEach((key, index) => {
      if (firstobj[index] !== secondobj[index]) {
        doesMatch = false;
      }
      if (typeof obj1[key] === 'string' && obj1[key] !== obj2[key]) {
        doesMatch = false;
      } else if (typeof obj1[key] === 'object') {
        obj1[key].forEach((value, index) => {
          if (value !== obj2[key][index]) {
            doesMatch = false;
          }
        });
      }
    });
    return doesMatch;
  } else if (obj1 || obj2) return false;
  else return true;
};
const _pricecalc = (obj) => {
  let total = 0;
  if (obj) {
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === 'string') {
        var split = obj[key].split('%');
        split.length === 2 ? (total += Number(split[1])) : null;
      } else {
        obj[key].forEach((strVal) => {
          var split = strVal.split('%');
          split.length === 2 ? (total += Number(split[1])) : null;
        });
      }
    });
  }
  return total;
};

var config = {
  apiKey: 'AIzaSyD5S2SjLfhNN50o2u1DEmxdZlUBrxhWQ60',
  authDomain: 'pizzeria-la-favole.firebaseapp.com',
  databaseURL: 'https://pizzeria-la-favole-be084.firebaseio.com/',
  // databaseURL: 'https://mhezzet.firebaseio.com/',
  projectId: 'pizzeria-la-favole',
  storageBucket: 'pizzeria-la-favole.appspot.com',
  messagingSenderId: '632837480784',
};
firebase.initializeApp(config);
export var database = firebase.database();

class App extends Component {
  state = {
    number: 0,
    total: 0,
    cart: [],
    menu: undefined,
    hasLoaded: false,
    isOpen: false,
    isMenu: false,
    willOpenIn: null,
    willCloseIn: null,
    callCenterText: '',
    hasVat: null,
    query: '',
    user_points: 0,
    hasRedeemed: false,
    expanded: false,
    branch_name: '',
    branch_id: '',
    page_id: '',
    areas: [],
    branches: [],
    restaurant_name: '',
    messenger_user_id: '',
    restaurant_name: '',
    websiteInfo: {},
    desktop: false,
    desktopUser: {},
    desktppUserID: '',
    nonAcceptedOrders: null,
    isFirstOrder: false,
    freeItem: {},
    env: '',
    displayName: '',
    minimum: 1,
    minimum_free_item: 1,
    freeItemFlag: false,
    pickUp: false,
    promoCode: '',
    promoCap: '',
    color: '',
    fetarOrASAP: false,
    data: '',
    lang: '',
  };

  setDesktopUser = (desktopUser) => {
    this.setState({ desktopUser });
  };

  setDesktppUserID = (desktppUserID) => {
    this.setState({ desktppUserID });
  };

  queryChange = (evt) => {
    this.setState({ query: evt.target.value });
  };

  static contextType = DesktopContext;
  componentDidMount() {
    axios
      .get(`http://worldtimeapi.org/api/ip`)
      .then((res) => {
        this.setState({ data: res.data });
      })
      .catch((err) => console.log(err.message));
    // console.log('freeItemFlaggg' + this.state.freeItemFlag);
    var url_string = window.location.href;
    var url = new URL(url_string);
    const options = {
      autoConfig: true, // set pixel's autoConfig
      debug: false, // enable logs
    };

    ReactPixel.init('2072061016256034', options);
    ReactPixel.pageView();

    ReactPixel.trackCustom(
      `desktop - ${url.searchParams.get('restaurant_name')} visits`
    );

    ReactPixel.trackCustom(`desktop - visits`);

    if (process.env.NODE_ENV == 'test') {
      var messenger_user_id = '';
      var restaurant_name = 'spicy';
      var user_latitude = '';
      var user_longitude = '';
      var user_phone = '';
      var user_address = '';
      var user_floor = '';
      var user_apartment = '';
      var user_first_name = '';
      var isMenu = '';
      var isPromo = '';
      var delivery_fees = '';
      var messenger_user_id = url.searchParams.get('messenger_user_id') || '';
      var restaurant_name = url.searchParams.get('restaurant_name') || '';
    } else {
      var messenger_user_id =
        url.searchParams.get('messenger_user_id') || '2151388794910164';
      var restaurant_name = url.searchParams.get('restaurant_name') || 'zooba';
      var user_latitude = url.searchParams.get('user_latitude') || '';
      var user_longitude = url.searchParams.get('user_longitude') || '';
      var user_first_name = url.searchParams.get('user_first_name') || '';
      var user_last_name = url.searchParams.get('user_last_name') || '';
      var isMenu = url.searchParams.get('isMenu') || false;
      var delivery_fees = url.searchParams.get('delivery_fees') || 0;
      var isPromo = url.searchParams.get('isPromo') || false;
      var promoCode = url.searchParams.get('promoCode') || '';
      var lang = url.searchParams.get('language') || '';
      var env = url.searchParams.get('env') || false;
    }
    var freeItemFlagg = url.searchParams.get('freeItemFlag') || false;
    // console.log('freeItemFlaggfreeItemFlagg' + freeItemFlagg);

    if (lang === 'ar') {
      strings.setLanguage('ar');
      this.setState({ lang: 'ar' });
    }

    if (lang === 'qrAR') {
      strings.setLanguage('qrAR');
      this.setState({ lang: 'qrAR' });
    }

    if (lang === 'qrEng') {
      strings.setLanguage('qrEng');
      this.setState({ lang: 'qrEng' });
    }

    database
      .ref(`restaurants/0/${restaurant_name}/branches`)
      .on('value', (snapshot) => {
        const snap = snapshot.val();
        if (snap) {
          this.setState({ branches: snap });
          if (isMenu) {
            this.getCategories(snap[0]);
          }
        }
      });
    var desktop = url.searchParams.get('desktop') || false;

    database
      .ref('/restaurants/0/' + restaurant_name + '/info')
      .on('value', (snapshot) => {
        if (snapshot.val()) {
          this.setState({
            displayName: snapshot.val().displayName || '',
            logo: snapshot.val().logo || '',
            color: snapshot.val().color || '',
            minimum: snapshot.val().minimum,
            minimum_free_item: snapshot.val().minimum_free_item,
            pickUp: snapshot.val().pickUp,
            promoCode: snapshot.val().promoCode,
            freeItemFlag: snapshot.val().freeItemFlag,
            promoCap: snapshot.val().promoCap || '',
            fetarOrASAP: snapshot.val().fetarOrASAP,
          });
        }
      });

    this.setState({ restaurant_name, messenger_user_id, desktop, env });

    this.setState(
      {
        messenger_user_id,
        user_latitude,
        user_longitude,
        user_last_name,
        user_first_name,
        delivery_fees: Number(delivery_fees),
        restaurant_name,
        isMenu,
        promoCode,
      },
      () => {
        if (!isMenu && !isPromo) {
        } else if (isPromo) {
          this.props.history.push('/redeem_offer');
        }
      }
    );

    if (!desktop) {
      database
        .ref(
          '/restaurants/0/' + restaurant_name + '/users/' + messenger_user_id
        )
        .on('value', (snapshot) => {
          if (snapshot.val()) {
            let points = snapshot.val().points;
            let user_address = snapshot.val().address || '';
            let user_phone = snapshot.val().phone || '';
            // let order_type = snapshot.val().type || '';
            let building = snapshot.val().building || '';
            let floor = snapshot.val().floor || '';
            let directions = snapshot.val().directions || '';
            let notes = snapshot.val().notes || '';
            let appartmentNo = snapshot.val().appartmentNo || '';
            let wholeAddress = snapshot.val().wholeAddress || '';
            let allNumbers = snapshot.val().allNumbers || '';
            let redeemedOffers = snapshot.val().redeemedOffers || [];
            this.setState({
              user_points: points,
              user_address,
              user_phone,
              // order_type,
              building,
              floor,
              directions,
              notes,
              appartmentNo,
              wholeAddress,
              allNumbers,
              redeemedOffers,
            });
          }
        });
    } else {
      //retrive desktop user data
    }

    firebase
      .database()
      .ref(`restaurants/0/${restaurant_name}/info`)
      .on('value', (snapshot) => {
        const snap = snapshot.val();

        if (snap && snap.pageID) {
          this.setState({ page_id: snap.pageID });
        }

        if (snap) {
          this.setState({
            messenger_bot_id: snap.messenger_bot_id,
          });
        }
      });

    let newAreas = [];

    database
      .ref(`restaurants/0/${restaurant_name}/checkedAreas`)
      .once('value', (snapshot) => {
        let snap = snapshot.val();

        if (snap && snap.length > 0) {
          snap.forEach((area) => {
            if (
              strings.getLanguage() === 'ar' ||
              (strings.getLanguage() === 'qrAR' && area.arabic_name)
            ) {
              newAreas.push({
                name: area.arabic_name,
                label: area.arabic_name,
                value: area.arabic_name,
                area_id: area.id,
                condition: area.condition,
                branch: area.branch,
                city: area.city,
              });
            } else {
              newAreas.push({
                name: area.name,
                label: area.name,
                value: area.name,
                area_id: area.id,
                condition: area.condition,
                branch: area.branch,
                city: area.city,
              });
            }
          });
          this.setState({ areas: newAreas, hasLoaded: true });
        } else {
          database
            .ref(`restaurants/0/${restaurant_name}/areas`)
            .once('value', (snapshot) => {
              let snap = snapshot.val();
              if (snap) this.setState({ areas: snap.working_areas });
              // added label and value because react-select needs it in order to show them
              this.state.areas.forEach((area) => {
                if (
                  area.condition &&
                  strings.getLanguage() === 'ar' &&
                  area.arabic_name
                ) {
                  newAreas.push({
                    name: area.arabic_name,
                    label: area.arabic_name,
                    value: area.arabic_name,
                    area_id: area.id,
                    condition: area.condition,
                  });
                } else if (area.condition) {
                  newAreas.push({
                    name: area.name,
                    label: area.name,
                    value: area.name,
                    area_id: area.id,
                    condition: area.condition,
                  });
                }
              });
              this.setState({
                areas: newAreas,
                hasLoaded: true,
              });
            });
        }
      });

    database
      .ref('/restaurants/0/' + restaurant_name + '/orders')
      .once('value')
      .then((snapshot) => {
        if (snapshot.val()) {
          // console.log(snapshot.val());
          const orders = Object.values(snapshot.val());
          const numberOfUserOrders = orders.filter(
            (order) =>
              order.messenger_user_id ===
              (desktop
                ? localStorage.getItem('desktppUserID')
                : messenger_user_id)
          );

          // console.log('man', numberOfUserOrders);
          // console.log('number of orders', numberOfUserOrders.length);
          // console.log(numberOfUserOrders.length);
          // console.log('zvv' + freeItemFlagg);

          this.setState({
            isFirstOrder: numberOfUserOrders.length > 0 ? false : true,
            // freeItemFlag: freeItemFlagg
          });

          if (!(numberOfUserOrders.length > 0)) {
            database
              .ref('/restaurants/0/' + restaurant_name + '/branches/0/freeItem')
              .once('value')
              .then((snapshot) => this.setState({ freeItem: snapshot.val() }));
          }
        } else {
          database
            .ref('/restaurants/0/' + restaurant_name + '/branches/0/freeItem')
            .once('value')
            .then((snapshot) =>
              this.setState({
                freeItem: snapshot.val(),
                isFirstOrder: true, // why?
              })
            );
        }
      });

    if (localStorage.getItem('desktppUserID')) {
      this.setDesktppUserID(localStorage.getItem('desktppUserID'));

      firebase
        .database()
        .ref('/restaurants/0/' + restaurant_name + '/orders')
        .orderByChild('messenger_user_id')
        .equalTo(localStorage.getItem('desktppUserID'))
        .on('value', (snapshot) => {
          const orders = snapshot.val();
          if (orders) {
            let count = Object.values(orders).filter(
              (order) => order.state === 1
            ).length;

            this.setState({ nonAcceptedOrders: count });
          }
        });

      database
        .ref(
          '/restaurants/0/' +
            restaurant_name +
            '/users/' +
            localStorage.getItem('desktppUserID')
        )
        .on('value', (snapshot) => {
          if (snapshot.val()) {
            let points = snapshot.val().points;
            let user_address = snapshot.val().address || '';
            let user_phone = snapshot.val().phone || '';
            // let order_type = snapshot.val().type || '';
            let building = snapshot.val().building || '';
            let floor = snapshot.val().floor || '';
            let directions = snapshot.val().directions || '';
            let notes = snapshot.val().notes || '';
            let appartmentNo = snapshot.val().appartmentNo || '';
            let wholeAddress = snapshot.val().wholeAddress;
            let allNumbers = snapshot.val().allNumbers;
            let first_name = snapshot.val().first_name || '';
            this.setState({
              user_points: points,
              user_address,
              user_phone,
              // order_type,
              building,
              floor,
              directions,
              notes,
              appartmentNo,
              wholeAddress,
              allNumbers,
              first_name,
            });
          }
        });
    } else {
      const id = uuid.v4();
      // console.log('idid' + id);
      const user = {
        id,
        source: 'desktop',
        points: 200,
        created_at: new Date(),
      };

      firebase
        .database()
        .ref('/restaurants/0/' + restaurant_name + '/users/' + id)
        .update(user)
        .then(() => {
          localStorage.setItem('desktppUserID', id);
          this.setDesktppUserID(id);
          this.setState({ points: 200 });
        });

      database
        .ref('/restaurants/0/' + restaurant_name + '/orders')
        .once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            // console.log(snapshot.val());
            const orders = Object.values(snapshot.val());
            const numberOfUserOrders = orders.filter(
              (order) => order.messenger_user_id === uuid.v4()
            );

            // console.log(numberOfUserOrders.length);

            this.setState({
              isFirstOrder: numberOfUserOrders.length > 0 ? false : true,
            });

            if (!(numberOfUserOrders.length > 0)) {
              database
                .ref(
                  '/restaurants/0/' + restaurant_name + '/branches/0/freeItem'
                )
                .once('value')
                .then((snapshot) =>
                  this.setState({ freeItem: snapshot.val() })
                );
            }
          } else {
            database
              .ref('/restaurants/0/' + restaurant_name + '/branches/0/freeItem')
              .once('value')
              .then((snapshot) =>
                this.setState({
                  freeItem: snapshot.val(),
                  isFirstOrder: true,
                })
              );
          }
        });
    }
  }

  addRedeemable = (index) => {
    var url =
      'https://us-central1-pizzeria-la-favole.cloudfunctions.net/elegate_redeem-1';
    //console.log("url" + url);
    let price = 0;
    let item_size = undefined;
    let redeemed_item = { ...this.state.redeemable_items[index] };
    if (typeof redeemed_item.price === 'object') {
      //find the smallest price

      Object.keys(redeemed_item.price).forEach((size) => {
        if (price === 0) price = redeemed_item.price[size];
        else if (price > redeemed_item.price[size]) {
          price = redeemed_item.price[size];
          item_size = size;
        }
      });
    } else {
      price = redeemed_item.price;
      item_size = 'regular';
    }
    let methodBody =
      'restaurant_name=' +
      this.state.restaurant_name +
      '&messenger_user_id=' +
      this.state.messenger_user_id +
      '&item_price_per_points=  ' +
      price * 10;
    let body = {
      restaurant_name: this.state.restaurant_name,
      messenger_user_id: this.state.messenger_user_id,
      item_price_per_points: price * 10,
    };
    fetch(url, {
      method: 'POST',
      //mode:"cors",

      body: JSON.stringify(body),
    }).then((res) => console.log(res));
    let cart = [...this.state.cart];
    redeemed_item.price = 0;
    redeemed_item.size = item_size; //this is buggy one
    redeemed_item.add_ons = {};
    redeemed_item.count = 1;
    cart.push(redeemed_item);

    this.setState({
      cart: cart,
      redeemed_item: this.state.redeemable_items[index],
      hasRedeemed: true,
    });
  };
  submitOrder = (
    phone,
    address,
    building,
    floor,
    directions,
    notes,
    appartmentNo,
    allNumbers,
    wholeAddress,
    fees,
    first_name,
    type,
    fetarTime,
    branch_name,
    branch_id
  ) => {
    let newCart = this.state.cart;
    // console.log('cart', this.state.cart);
    // console.log('minimum', this.state.minimum_free_item);
    console.log('promoCap' + this.state.promoCap);
    if (
      this.state.isFirstOrder &&
      this.state.freeItemFlag &&
      this.state.total >= this.state.minimum_free_item
    ) {
      newCart.push({
        count: 1,
        price: 0,
        name: this.state.freeItem.name + ' (Free - هدية)',
      });
    }
    const min = 1;
    const max = 10000;
    const rand = (min + Math.random() * (max - min)).toFixed(0);

    // console.log('promoCode' + this.state.promoCode);
    // !if pick up -> delivery fees = 0
    let totalDiscounted = (this.state.total * this.state.promoCode) / 100;
    let final_total;
    if (type === 'pickUp') {
      if (this.state.promoCode) {
        if (this.state.total - totalDiscounted > this.state.promoCap) {
          // check if total within promoCode cap
          final_total = this.state.hasVat
            ? (this.state.total - this.state.promoCap) * 1.14
            : this.state.total - this.state.promoCap;
        } else {
          final_total = this.state.hasVat
            ? totalDiscounted * 1.14
            : totalDiscounted;
        }
      } else {
        final_total = this.state.hasVat
          ? this.state.total * 1.14
          : this.state.total;
      }
      fees = 0;
    } else {
      if (this.state.promoCode) {
        if (this.state.total - totalDiscounted > this.state.promoCap) {
          final_total = this.state.hasVat
            ? (this.state.total -
                this.state.promoCap +
                this.state.delivery_fees) *
              1.14
            : this.state.total - this.state.promoCap + this.state.delivery_fees;
          console.log('final_total promo' + final_total);
        } else {
          final_total = this.state.hasVat
            ? ((this.state.total * this.state.promoCode) / 100 +
                this.state.delivery_fees) *
              1.14
            : (this.state.total * this.state.promoCode) / 100 +
              this.state.delivery_fees;
          console.log('final_total promo' + final_total);
        }
      } else {
        final_total = this.state.hasVat
          ? (this.state.total + this.state.delivery_fees) * 1.14
          : this.state.total + this.state.delivery_fees;
        console.log('final_total not promo' + final_total);
      }
    }

    let cart = { ...this.state.cart };

    for (var i in cart) {
      if (cart[i].add_ons) {
      } else {
        cart[i].add_ons = {};
      }
    }
    var ordersRef = database.ref(
      '/restaurants/0/' + this.state.restaurant_name + '/orders'
    );

    let order_ref = ordersRef.push();
    let order_key = order_ref.key;
    // console.log('address' + address);
    order_ref
      .set({
        source: this.state.desktop ? 'desktop' : 'chatbot',
        name: this.state.user_first_name || first_name,
        phone: phone || this.state.user_phone,
        type: type || this.state.order_type,
        fetarTime: fetarTime || '',
        address: address || this.state.user_address || '',
        building: building || '',
        floor: floor || '',
        appartmentNo: appartmentNo || '',
        directions: directions ? directions : null,
        notes: notes ? notes : null,
        cart:
          this.state.isFirstOrder &&
          this.state.freeItemFlag &&
          this.state.total >= this.state.minimum_free_item
            ? newCart
            : cart,
        total: Number(Number(final_total.toFixed(2)).toFixed(2)),
        delivery_fees: fees || 0,
        timestamp: Moment().format(),
        // branch_name: this.state.branch_name,
        branch_name: branch_name ? branch_name : null,
        // branch_id: this.state.branch_id || '',
        branch_id: branch_id ? branch_id : null,
        area_name: this.state.area_name || '',
        items: '',
        state: 1,
        messenger_user_id: this.state.desktop
          ? this.state.desktppUserID
          : this.state.messenger_user_id,
        user_latitude: this.state.user_latitude,
        user_longitude: this.state.user_longitude,
        user_last_name: this.state.user_last_name,
        id: rand,
      })
      .then((res) => {
        // console.log(res);
        // Number((Number((final_total).toFixed(2))).toFixed(2)
        let user_ref = database.ref(
          '/restaurants/0/' +
            this.state.restaurant_name +
            '/users/' +
            (this.state.desktop
              ? this.state.desktppUserID
              : this.state.messenger_user_id)
        );
        database
          .ref(
            '/restaurants/0/' +
              this.state.restaurant_name +
              '/users/' +
              (this.state.desktop
                ? this.state.desktppUserID
                : this.state.messenger_user_id)
          )
          .once('value', (snapshot) => {
            if (snapshot.val()) {
              let points = snapshot.val().points;
              // console.log('points' + points + 'final total' + final_total);
              this.setState({
                user_points: points + final_total,
              });
              // update user's points
              user_ref.update({
                points: this.state.user_points,
                address: address || '',
                phone: phone,
                type: type,
                fetarTime: fetarTime,
                building: building || '',
                floor: floor || '',
                appartmentNo: appartmentNo || '',
                directions: directions ? directions : null,
                notes: notes ? notes : null,
                allNumbers,
                wholeAddress,
                ...(this.state.desktop && { first_name }),
              });
            }
          });

        if (!this.state.env) {
          // console.log({ restaurant_name: this.state.restaurant_name });

          axios
            .post(
              'https://europe-west2-pizzeria-la-favole.cloudfunctions.net/order_alert',
              { restaurant_name: this.state.restaurant_name },
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            )
            .then((res) => console.log(res))
            .catch((err) => console.log(err));
        }

        if (this.state.desktop) {
          this.props.history.push('/history');
          return;
        }

        //update user points
        if (!this.state.page_id) {
          var url =
            'https://api.chatfuel.com/bots/' +
            this.state.messenger_bot_id +
            '/users/' +
            this.state.messenger_user_id +
            '/send?chatfuel_token=mELtlMAHYqR0BvgEiMq8zVek3uYUK3OJMbtyrdNPTrQB9ndV0fM7lWTFZbM4MZvD&chatfuel_message_tag=POST_PURCHASE_UPDATE&chatfuel_block_name=order_received&last_order_id=' +
            order_key;
          // console.log('url' + url);
          fetch(url, {
            method: 'POST',
            //add mode:"cors"
          })
            .then((response) => {
              response.json();
              // window.extAsyncInit = function() {
              //   // the Messenger Extensions JS SDK is done loading
              //   requestCloseBrowser();
              // };
            }) // parses response to JSON
            .catch((error) => console.log('Fetch Error =\n', error));
        } else {
          fetch('https://chatbot.elegate.org/orderRecived', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              userID: this.state.messenger_user_id,
              pageID: this.state.page_id,
            }),
          });
        }
        this.props.history.push('/history');
      });
  };
  clear = () => {
    this.setState({
      query: '',
    });
  };
  goToCheckout = () => this.setState({ mode: 'checkout' });
  goToOrdering = () => this.setState({ mode: 'ordering' });
  goToItemInfo = (item) => {
    this.setState({ chosen_item: item });
    this.props.history.push('/additem');
  };
  clickHandler = (item, quantity, size, add_ons, cart, note) => {
    //chosen size details holds size in the first index and price in the second
    var counter = cart ? cart.length : 1;
    var newcart = [...this.state.cart];
    var new_total = 0;
    //removes the empty array from the add ons to allow the matching of stored items and old items coming from history
    //*************************TODO REMOVE THIS LINE AND ADJSUT ADDITEM ADDONS**************************** */
    if (!cart)
      Object.keys(add_ons).forEach((key) => {
        if ((typeof add_ons[key] === 'object') & (add_ons[key].length == 0))
          delete add_ons[key];
      });

    //Either inserts an entire cart or loops a single item to insert one item on regular function calls
    for (var i = 0; i < counter; i++) {
      //regular flow when ordering one item
      if (!cart) {
        var chosen_size_details = size.split('%');
        // console.log("current cart length is",this.state.cart.length);
        var price = chosen_size_details[1]
          ? Number(chosen_size_details[1])
          : Number(item.price_of_one);

        var found = false;
      }
      //when inserting an entire cart
      else {
        var item = { ...cart[i] };
        var chosen_size_details = cart[i].size ? cart[i].size.split('%') : '';
        var price = chosen_size_details[1]
          ? Number(chosen_size_details[1])
          : Number(item.price_of_one);
        var found = false;
        var quantity = cart[i].count;
        var size = cart[i].size;
        var add_ons = cart[i].add_ons;
      }
      newcart = newcart.map((cartitem) => {
        if (
          cartitem.item_id !== item.item_id ||
          cartitem.size !== chosen_size_details[0] ||
          !_matchObjects(cartitem.add_ons, add_ons)
        )
          return cartitem;
        else {
          var temp = { ...cartitem };
          temp.count += quantity;
          found = true;
          //checks if the price is accumulative or it is the price of one item only
          new_total =
            (i == 0 ? this.state.total : 0) +
            (item.price_of_one
              ? Number(item.price)
              : Number(price) * Number(quantity)) +
            Number(new_total);
          temp.price =
            Number(temp.price) +
            Number(item.price_of_one ? item.price : Number(price) * quantity);
          return temp;
        }
      });
      if (found) {
      } else {
        if (!price) continue;
        new_total =
          (i == 0 ? this.state.total : 0) +
          price * quantity +
          _pricecalc(add_ons) * quantity +
          new_total;
        // console.log('new total progress', price);
        newcart.push({
          ...item,
          count: quantity,
          size: chosen_size_details[0],
          price_of_one: Number(price),
          price: Number(
            (price * quantity + _pricecalc(add_ons) * quantity).toFixed(2)
          ),
          add_ons: add_ons,
          note: note ? note : null,
        });
      }
    }

    // console.log('new total', new_total);
    newcart = newcart.filter((item) => item.size);
    // console.log('new cart', newcart);
    this.setState({
      cart: newcart,
      total: Number(Number(new_total).toFixed(2)),
    });
  };
  addItem = (index) => {
    var newcart = [...this.state.cart];
    var newtotal = this.state.total;
    newcart[index].count++;
    newtotal += newcart[index].price_of_one;
    newcart[index].price += newcart[index].price_of_one;

    this.setState({ cart: newcart, total: Number(newtotal.toFixed(2)) });
  };
  removeItem = (index) => {
    var newcart = [...this.state.cart];
    var newtotal = this.state.total;

    if (newcart[index].count > 1) {
      newcart[index].count--;
      newtotal -= newcart[index].price_of_one;
      newcart[index].price -= newcart[index].price_of_one;
      this.setState({ cart: newcart, total: Number(newtotal.toFixed(2)) });
    }
  };
  deleteItem = (index) => {
    var newcart = [...this.state.cart];
    var newtotal = this.state.total;
    newtotal -= Number(newcart[index].price);
    newcart.splice(index, 1);
    this.setState({
      cart: newcart,
      total: Number(Number(newtotal).toFixed(2)),
    });
  };

  handleExpand = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  // Check if branch is open
  checkIfOpen = (branch) => {
    // console.log(branch);
    let val = branch.info;
    let hasVat = val.hasVat;

    this.setState({ hasVat: hasVat });

    let utcDate = this.state.data.utc_datetime;

    let getLocalTimeFromIp = moment
      .utc(utcDate)
      .utcOffset(this.state.data.utc_offset)
      .format('HH:mm:ss');

    let current_time = Moment(getLocalTimeFromIp, 'HH:mm:ss');
    console.log('current_time', current_time);
    let current_day = this.state.data.day_of_week;

    let opening = val.opening_hours[current_day].opening;
    let closing = val.opening_hours[current_day].closing;

    let day_before;

    current_day === 0 ? (day_before = 6) : (day_before = current_day - 1);

    let closing_before = val.opening_hours[day_before % 7].closing;
    // let opening_before = val.opening_hours[day_before % 7].opening;

    let closing_before_hour = Moment(closing_before, 'HH:mm');

    const twelve = Moment('00:00:00', 'HH:mm:ss');
    console.log('twelve', twelve);
    const three = Moment('03:00:00', 'HH:mm:ss');
    console.log('three', three);

    if (current_time.isBetween(twelve, three)) {
      if (
        current_time.format('HH') < closing_before_hour.format('HH') &&
        closing_before_hour.format('HH') < 3
      ) {
        this.setState({ isOpen: true });
      } else {
        this.setState({
          willOpenIn: val.opening_hours[current_day % 7].opening,
          willCloseIn: val.opening_hours[current_day % 7].closing,
          callCenterText: callCenterText,
        });
        return;
      }
    }

    let callCenterText = val.opening_hours.call_center || '';

    let opening_hour = Moment(opening, 'HH:mm:ss');
    let close_hour = Moment(closing, 'HH:mm:ss');

    if (close_hour.isAfter(opening_hour)) {
      if (current_time.isBetween(opening_hour, close_hour)) {
        this.setState({ isOpen: true });
      } else {
        this.setState({
          willOpenIn: val.opening_hours[(current_day + 1) % 7].opening,
          willCloseIn: val.opening_hours[(current_day + 1) % 7].closing,
          callCenterText: callCenterText,
        });
      }
    } else {
      if (
        current_time.isAfter(opening_hour) ||
        current_time.isBefore(close_hour)
      ) {
        this.setState({ isOpen: true });
      } else {
        this.setState({
          willOpenIn: val.opening_hours[(current_day + 1) % 7].opening,
          willCloseIn: val.opening_hours[(current_day + 1) % 7].closing,
          callCenterText: callCenterText,
        });
      }
    }
  };

  getBranchInfo = (branch) => {
    this.setState({ websiteInfo: branch.info.website || {} });
  };

  getCategories = (branch) => {
    this.checkIfOpen(branch);
    this.getBranchInfo(branch);
    this.setState({ hasLoaded: false });

    let temp = [];
    let categories = [];
    let redeemable_temp = [];

    branch.categories.forEach((category) => {
      temp.push({
        category_name: category.category_name,
        category_items: category.items,
      });

      categories.push(category.category_name);

      for (var item in category.items) {
        if (category.items[item].isRedeemable) {
          redeemable_temp.push({ ...category.items[item] });
        }
      }
    });
    // console.log('PROMO CODEEE', this.state.promoCode);
    this.setState({
      redeemable_items: redeemable_temp,
      menu: temp,
      categories: categories,
      hasLoaded: true,
    });

    this.props.history.push('/order');
  };

  // Get area name when selected to send it with the order
  getAreaName = (areaName) => {
    this.setState({ area_name: areaName });
  };

  // Get Branch name
  getBranch = (branch, fees) => {
    this.setState({
      branch_name: branch.label || '',
      branch_id: branch.branch_id || '',
      delivery_fees: Number(fees) || 0,
    });
  };

  render() {
    return (
      <Provider>
        <DesktopContext.Provider
          value={{
            desktop: this.state.desktop,
            desktopUser: this.state.desktopUser,
            desktppUserID: this.state.desktppUserID,
            setDesktopUser: this.setDesktopUser,
            setDesktppUserID: this.setDesktppUserID,
          }}
        >
          <div className='App'>
            <Switch>
              {this.state.cart.length >= 1 ? (
                <Route
                  exact
                  path='/checkout'
                  render={(routeProps) => (
                    <Checkout
                      {...routeProps}
                      branches={this.state.branches}
                      branch_name={this.state.branch_name}
                      branch_id={this.state.branch_id}
                      pickUp={this.state.pickUp}
                      hasVat={this.state.hasVat}
                      cart={this.state.cart}
                      total={this.state.total}
                      back={this.goToOrdering}
                      submit_order={this.submitOrder}
                      delivery_fees={this.state.delivery_fees}
                      redeemableItems={this.state.redeemable_items}
                      user_points={this.state.user_points}
                      hasRedeemed={this.state.hasRedeemed}
                      redeem={this.addRedeemable}
                      expanded={this.state.expanded}
                      expand={this.handleExpand}
                      user_address={this.state.user_address}
                      user_phone={this.state.user_phone}
                      order_type={this.state.order_type}
                      building={this.state.building}
                      floor={this.state.floor}
                      directions={this.state.directions}
                      notes={this.state.notes}
                      appartmentNo={this.state.appartmentNo}
                      wholeAddress={this.state.wholeAddress}
                      allNumbers={this.state.allNumbers}
                      restaurant_name={this.state.restaurant_name}
                      messenger_user_id={this.state.messenger_user_id}
                      desktop={this.state.desktop}
                      first_name={this.state.first_name}
                      desktopInfo={this.state.websiteInfo}
                      freeItem={this.state.freeItem}
                      freeItemFlag={this.state.freeItemFlag}
                      isFirstOrder={this.state.isFirstOrder}
                      minimum={this.state.minimum}
                      minimum_free_item={this.state.minimum_free_item}
                      promoCode={this.state.promoCode}
                      promoCap={this.state.promoCap}
                      color={this.state.color}
                      fetarOrASAP={this.state.fetarOrASAP}
                      lang={this.state.lang}
                    />
                  )}
                />
              ) : null}
              <Route
                exact
                path='/additem'
                render={(routeProps) => (
                  <ItemInfo
                    cart={this.state.cart}
                    {...routeProps}
                    messenger_user_id={this.state.messenger_user_id}
                    restaurant_name={this.state.restaurant_name}
                    chosen_item={this.state.chosen_item}
                    click={this.clickHandler}
                    changemode={this.goToOrdering}
                    promoCode={this.state.promoCode}
                    color={this.state.color}
                    lang={this.state.lang}
                  />
                )}
              />
              <Route
                exact
                path='/order'
                render={(routeProps) => (
                  <Ordering
                    {...routeProps}
                    hasLoaded={this.state.hasLoaded}
                    clear={this.clear}
                    cart={this.state.cart}
                    click={this.goToItemInfo}
                    categories={this.state.categories}
                    menu={this.state.menu}
                    total={this.state.total}
                    isOpen={this.state.isOpen}
                    willOpenIn={this.state.willOpenIn}
                    willCloseIn={this.state.willCloseIn}
                    callCenterText={this.state.callCenterText}
                    messenger_user_id={this.state.messenger_user_id}
                    query={this.state.query}
                    queryChange={this.queryChange}
                    restaurant_name={this.state.restaurant_name}
                    messenger_user_id={this.state.messenger_user_id}
                    nonAcceptedOrders={this.state.nonAcceptedOrders}
                    info={this.state.websiteInfo}
                    freeItemFlag={this.state.freeItemFlag}
                    isFirstOrder={this.state.isFirstOrder}
                    freeItem={this.state.freeItem}
                    promoCode={this.state.promoCode}
                    color={this.state.color}
                    logo={this.state.logo}
                  />
                )}
              />
              <Route
                exact
                path='/editcart'
                render={(routeProps) => (
                  <EditCart
                    {...routeProps}
                    cartitems={this.state.cart}
                    total={this.state.total}
                    addItem={this.addItem}
                    removeItem={this.removeItem}
                    deleteItem={this.deleteItem}
                    promoCode={this.state.promoCode}
                    color={this.state.color}
                  />
                )}
              />
              <Route
                exact
                path='/order_sent'
                render={(routeProps) => (
                  <CheckoutSuccessAnim
                    {...routeProps}
                    desktop={this.state.desktop}
                    messenger_user_id={this.state.messenger_user_id}
                  />
                )}
              />
              <Route
                exact
                path='/history'
                render={(routeProps) => (
                  <History
                    restaurant_name={this.state.restaurant_name}
                    messenger_user_id={
                      this.state.desktop
                        ? this.state.desktppUserID
                        : this.state.messenger_user_id
                    }
                    add_items={this.clickHandler}
                    {...routeProps}
                    color={this.state.color}
                    lang={this.state.lang}
                  />
                )}
              />
              <Route
                exact
                path='/'
                render={(routeProps) =>
                  !this.state.isMenu ? (
                    <ChooseArea
                      {...routeProps}
                      restaurant_name={this.state.restaurant_name}
                      branches={this.state.branches}
                      messenger_user_id={this.state.messenger_user_id}
                      messenger_bot_id={this.state.messenger_bot_id}
                      getCategories={this.getCategories}
                      getArea={this.getAreaName}
                      getBranch={this.getBranch}
                      areas={this.state.areas}
                      displayName={this.state.displayName}
                      logo={this.state.logo}
                      color={this.state.color}
                      lang={this.state.lang}
                    />
                  ) : (
                    <Ordering
                      {...routeProps}
                      hasLoaded={this.state.hasLoaded}
                      clear={this.clear}
                      cart={this.state.cart}
                      click={this.goToItemInfo}
                      categories={this.state.categories}
                      menu={this.state.menu}
                      total={this.state.total}
                      isOpen={this.state.isOpen}
                      willOpenIn={this.state.willOpenIn}
                      willCloseIn={this.state.willCloseIn}
                      callCenterText={this.state.callCenterText}
                      messenger_user_id={this.state.messenger_user_id}
                      query={this.state.query}
                      queryChange={this.queryChange}
                      restaurant_name={this.state.restaurant_name}
                      nonAcceptedOrders={this.state.nonAcceptedOrders}
                      info={this.state.websiteInfo}
                      isFirstOrder={this.state.isFirstOrder}
                      freeItem={this.state.freeItem}
                      freeItemFlag={this.state.freeItemFlag}
                      promoCode={this.state.promoCode}
                      logo={this.state.logo}
                      color={this.state.color}
                    />
                  )
                }
              />
              <Route
                exact
                path='/not-available'
                render={(routeProps) => <AreaFalse {...routeProps} />}
              />
              <Route
                exact
                path='/redeem_offer'
                render={(routeProps) => (
                  <RedeemOffer
                    {...routeProps}
                    restaurant_name={this.state.restaurant_name}
                    promoCode={this.state.promoCode}
                    messenger_user_id={this.state.messenger_user_id}
                    redeemedOffers={this.state.redeemedOffers}
                  />
                )}
              />
              <Route exact path='/offer_redeemed' component={Gift} />
              <Route
                exact
                path='/about'
                render={(props) => (
                  <Footer
                    info={this.state.websiteInfo}
                    color={this.state.color}
                    lang={this.state.lang}
                    {...props}
                  />
                )}
              />
            </Switch>
          </div>
        </DesktopContext.Provider>
      </Provider>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js